
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/chat/chat-box",
      function () {
        return require("private-next-pages/x/api/chat/chat-box.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/chat/chat-box"])
      });
    }
  